import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { setHeaderTitle } from '../redux/slices/layoutSlice';
import { setSearchString, tlistSelector } from '../redux/slices/questionsSlice';

/**
 * Custom hook for managing the tag page's state and navigation.
 *
 * @returns tlist - An array of tag data retrieved from the server
 * @returns clickTag - Function to navigate to the home page with the selected tag as a URL parameter.
 */
const useTagPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const tlist = useAppSelector(tlistSelector) || [];

  /**
   * Function to navigate to the home page with the specified tag as a search parameter.
   *
   * @param tagName - The name of the tag to be added to the search parameters.
   */
  const clickTag = (tagName: string) => {
    dispatch(setSearchString(`[${tagName}]`));
    const searchParams = new URLSearchParams();
    searchParams.set('tag', tagName);
    navigate(`/questions?${searchParams.toString()}`);
  };

  useEffect(() => {
    dispatch(setHeaderTitle('Tags'));
  }, [dispatch]);

  return { tlist, clickTag };
};

export default useTagPage;
